"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildAnalyticUrl = void 0;
const buildAnalyticUrl = (baseUrl, { utmMedium, utmSource }) => {
    try {
        const url = new URL(baseUrl);
        url.searchParams.set('utm_medium', utmMedium);
        url.searchParams.set('utm_source', utmSource);
        return url.toString();
    }
    catch (_a) {
        return undefined;
    }
};
exports.buildAnalyticUrl = buildAnalyticUrl;
